import React from "react";
import Header from "../../components/Header";
import FooterTwo from "../../components/Footer/FooterTwo";
import Breadcrumb from "../../components/Breadcrumb";
import ScrollToTop from "../../components/ScrollTop";

import Logo from "../../assets/images/logos/logo2.png";
import UpscResourcesMain from "./UpscResourcesMain";
import { FREE_RESOURCES } from "./upsc-resources-constants";

const UpscResources = () => {
  return (
    <>
      <Header
        parentMenu="page"
        menuCategoryEnable="enable"
        headerNormalLogo={Logo}
        headerStickyLogo={Logo}
        topbarEnable="enable"
      />

      <div class="react-wrapper">
        <div class="react-wrapper-inner">
          <Breadcrumb pageTitle="UPSC Resources" />

          <UpscResourcesMain upscResources={FREE_RESOURCES} />
        

          {/* scrolltop-start */}
          <ScrollToTop />
          {/* scrolltop-end */}
        </div>
      </div>

      <FooterTwo />
    </>
  );
};

export default UpscResources;
